"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var axios_1 = __importDefault(require("axios"));
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var browser_1 = require("@sentry/browser");
var mobx_1 = require("mobx");
var item_input_card_store_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/common/item_input_card_store"));
var item_input_card_list_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/item_input_card_list"));
var assign_item_value_to_input_props_1 = require("@hikakaku/shared/util/assign_item_value_to_input_props");
var recommended_import_category_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/recommended_import_category_store"));
var xor_1 = __importDefault(require("lodash/xor"));
var classnames_1 = __importDefault(require("classnames"));
var RECOMMENDED_IMPORT_CATEGORIES_API_URL = '/api/import_categories/recommendations';
var ItemInputCardListStore = /** @class */ (function () {
    function ItemInputCardListStore(props) {
        var _this = this;
        this.component = item_input_card_list_1.default;
        this.recommendedImportCategories = [];
        this.recommendedImportCategoryListStore = [];
        this.recommendedImportCategoriesDisplayable = false;
        this.itemInputCardStores = [];
        this.showsMultipleItemRecommendation = true;
        this.isNextButtonDisabled = false;
        this.lastCardNumber = 0;
        this.selectedImportCategoryIds = [];
        this.handleClickAddItemButton = function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this.addItemCard(_this.defaultItemInputProps);
            _this.defaultImportCategoryId && _this.onClickAddItemButton(_this.defaultImportCategoryId);
        };
        this.handleClickRecommendedImportCategoryButton = function (importCategoryId, importCategoryGroupId) {
            _this.fetchCategoryItemInputList(String(importCategoryId))
                .then(function (props) {
                _this.updateDefaultCardProps(props, String(importCategoryId), String(importCategoryGroupId));
                _this.addItemCard(props);
            });
        };
        this.insertItem = function (item) {
            // カテゴリが選択されていない or 選択済みのカテゴリが一致している状態で商品名が入力されていない
            // そのカードに情報が入ったように見せるため、いったん消してしまう
            if (!_this.lastItemCard.hasImportCategoryId ||
                (_this.lastItemCard.isCategorySelected(String(item.importCategoryId)) && !_this.lastItemCard.hasValueInInputStoreByRawName('name'))) {
                _this.itemInputCardStores.pop();
            }
            if (_this.defaultImportCategoryId === String(item.importCategoryId) && _this.defaultItemInputProps) {
                _this.addItemCard(_this.defaultItemInputProps, item);
                return Promise.resolve(_this.lastItemCard.index + 1);
            }
            else {
                return _this.fetchCategoryItemInputList(String(item.importCategoryId))
                    .then(function (props) {
                    _this.updateDefaultCardProps(props, String(item.importCategoryId));
                    _this.addItemCard(props, item);
                    return _this.lastItemCard.index + 1;
                });
            }
        };
        this.validate = function () {
            return _this.itemInputCardStores.every(function (cardStore) { return cardStore.validate(); });
        };
        this.addItemCard = function (inputProps, item, createCategorySelectorOptionStore) {
            if (createCategorySelectorOptionStore === void 0) { createCategorySelectorOptionStore = true; }
            var itemInputProps = inputProps && (item
                ? (0, assign_item_value_to_input_props_1.assignItemValueToInputProps)(item, inputProps(_this.lastCardNumber))
                : inputProps(_this.lastCardNumber));
            _this.itemInputCardStores.push(new item_input_card_store_1.default({
                cardNumber: _this.lastCardNumber,
                categorySelectorOptions: createCategorySelectorOptionStore ? _this.categorySelectorOptions : undefined,
                fetchCategoryItemInputList: _this.handleFetchItemInputList(_this.lastCardNumber),
                onClickDeleteButton: _this.deleteItemInputCardStore,
                inputProps: itemInputProps,
                defaultImportCategoryGroup: _this.defaultImportCategoryGroupId,
                defaultImportCategory: _this.defaultImportCategoryId
            }));
            _this.lastCardNumber++;
        };
        this.deleteItemInputCardStore = function (index) {
            _this.itemInputCardStores.splice(index, 1);
            _this.defaultImportCategoryGroupId = undefined;
            _this.defaultImportCategoryId = undefined;
            _this.defaultItemInputProps = undefined;
            if (_this.itemInputCardStores.length === 0) {
                _this.addItemCard();
            }
        };
        this.handleChangeItemInputCardStores = function (change) {
            change.object.forEach(function (store, idx) {
                store.index = idx;
                // Keep the back-to-step0 button on whichever card is currently first
                store.topElementStore = idx === 0 ? _this.firstCardTopElementStore : undefined;
            });
        };
        this.handleFetchItemInputList = function (cardNumber) { return function (categoryId) {
            return _this.fetchCategoryItemInputList(categoryId)
                .then(function (props) {
                _this.defaultImportCategoryId = categoryId;
                _this.defaultItemInputProps = props;
                return props(cardNumber);
            });
        }; };
        this.handleChangeSelectedImportCategories = function () {
            var query = qs_1.default.stringify((0, convert_case_keys_1.toSnakeKeys)({ importCategoryIds: _this.selectedImportCategoryIds.slice() }));
            axios_1.default
                .get("".concat(RECOMMENDED_IMPORT_CATEGORIES_API_URL, "?").concat(query))
                .then(function (response) {
                _this.recommendedImportCategories = response.data.data;
            })
                .catch(function (e) {
                window.DialogStore.showErrorDialog();
                (0, browser_1.captureException)(e);
            });
        };
        this.handleChangeRecommendedImportCategories = function () {
            _this.recommendedImportCategoryListStore = _this.recommendedImportCategories.map(function (importCategory) { return (new recommended_import_category_store_1.default({
                importCategory: importCategory,
                onClick: _this.handleClickRecommendedImportCategoryButton
            })); });
        };
        this.handleChangeItemInputCardValues = function () {
            var currentImportCategoryIds = _this
                .values
                .filter(function (inputCard) { return (inputCard['import_category_id'] !== undefined && String(inputCard['import_category_id']['value']).length > 0); }).map(function (inputCard) { return (String(inputCard['import_category_id']['value'])); });
            var idsDiff = (0, xor_1.default)(_this.selectedImportCategoryIds, currentImportCategoryIds);
            if (idsDiff.length > 0) {
                _this.selectedImportCategoryIds = currentImportCategoryIds;
            }
        };
        this.updateDefaultCardProps = function (props, importCategoryId, ImportCategoryGroupId) {
            _this.defaultItemInputProps = props;
            _this.defaultImportCategoryId = importCategoryId;
            if (ImportCategoryGroupId !== undefined) {
                _this.defaultImportCategoryGroupId = ImportCategoryGroupId;
            }
        };
        this.handleClickNextButton = function (event) {
            event.stopPropagation();
            event.preventDefault();
            _this.onClickNextButton && _this.onClickNextButton(event);
        };
        (0, mobx_1.observe)(this.itemInputCardStores, this.handleChangeItemInputCardStores);
        this.categorySelectorOptions = props.categorySelectorOptions;
        this.fetchCategoryItemInputList = props.fetchCategoryItemInputList;
        this.onClickAddItemButton = props.onClickAddItemButton;
        this.defaultImportCategoryGroupId = props.defaultImportCategoryGroupId;
        this.defaultImportCategoryId = props.defaultImportCategoryId;
        this.defaultItemInputProps = props.defaultItemInputProps;
        this.recommendedImportCategoriesDisplayable = Boolean(props.recommendedImportCategoriesDisplayable);
        this.onClickNextButton = props.handleClickNextButton;
        this.firstCardTopElementStore = props.firstCardTopElementStore;
        props.itemCardInputProps.forEach(function (inputProps) { return _this.addItemCard(inputProps, undefined, false); });
        (0, mobx_1.reaction)(function () { return _this.values; }, this.handleChangeItemInputCardValues);
        (0, mobx_1.reaction)(function () { return _this.selectedImportCategoryIds; }, this.handleChangeSelectedImportCategories);
        (0, mobx_1.reaction)(function () { return _this.recommendedImportCategories; }, this.handleChangeRecommendedImportCategories);
        (0, mobx_1.reaction)(function () { return _this.itemInputCardStores.map(function (store) { return ({ groupId: store.groupId }); }); }, function (stores) {
            var _a, _b, _c;
            var groupId = (_c = (_b = (_a = stores[0]) === null || _a === void 0 ? void 0 : _a.groupId) === null || _b === void 0 ? void 0 : _b.match(/\d+$/)) === null || _c === void 0 ? void 0 : _c[0];
            _this.defaultImportCategoryGroupId = groupId;
        });
        if (props.itemCardInputProps.length === 0) {
            this.addItemCard(this.defaultItemInputProps);
        }
    }
    Object.defineProperty(ItemInputCardListStore.prototype, "showsNextButton", {
        get: function () {
            return Boolean(this.onClickNextButton);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemInputCardListStore.prototype, "values", {
        get: function () {
            return this.itemInputCardStores.map(function (card) { return card.value; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemInputCardListStore.prototype, "showsAddItemButton", {
        get: function () {
            // FIXME: defaultImportCategoryId で判定するのも変だが、直すメリットが薄いから放置している
            return Boolean(this.defaultImportCategoryId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemInputCardListStore.prototype, "lastItemCard", {
        get: function () {
            return this.itemInputCardStores[this.itemInputCardStores.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemInputCardListStore.prototype, "showsRecommendedImportCategories", {
        get: function () {
            return this.recommendedImportCategoriesDisplayable && this.recommendedImportCategories.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemInputCardListStore.prototype, "nextButtonClassNames", {
        get: function () {
            return (0, classnames_1.default)('estimateForm-ItemInputCardList_ButtonGroup_NextButton', { 'estimateForm-ItemInputCardList_ButtonGroup_NextButton-disabled': this.isNextButtonDisabled });
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ItemInputCardListStore.prototype, "recommendedImportCategories", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ItemInputCardListStore.prototype, "recommendedImportCategoryListStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "recommendedImportCategoriesDisplayable", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ItemInputCardListStore.prototype, "itemInputCardStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "showsMultipleItemRecommendation", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], ItemInputCardListStore.prototype, "isNextButtonDisabled", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "lastCardNumber", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], ItemInputCardListStore.prototype, "selectedImportCategoryIds", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ItemInputCardListStore.prototype, "defaultImportCategoryGroupId", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ItemInputCardListStore.prototype, "defaultImportCategoryId", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Function)
    ], ItemInputCardListStore.prototype, "defaultItemInputProps", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ItemInputCardListStore.prototype, "showsNextButton", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ItemInputCardListStore.prototype, "values", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ItemInputCardListStore.prototype, "showsAddItemButton", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof item_input_card_store_1.IItemInputCardStore !== "undefined" && item_input_card_store_1.IItemInputCardStore) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], ItemInputCardListStore.prototype, "lastItemCard", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ItemInputCardListStore.prototype, "showsRecommendedImportCategories", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ItemInputCardListStore.prototype, "nextButtonClassNames", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "handleClickAddItemButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "handleClickRecommendedImportCategoryButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "insertItem", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "addItemCard", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "deleteItemInputCardStore", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "handleChangeItemInputCardStores", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "handleFetchItemInputList", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "handleChangeSelectedImportCategories", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "handleChangeRecommendedImportCategories", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ItemInputCardListStore.prototype, "handleChangeItemInputCardValues", void 0);
    return ItemInputCardListStore;
}());
exports.default = ItemInputCardListStore;
